// extracted by mini-css-extract-plugin
export default {"main":"DashboardPage_main__+OJ1O","stats":"DashboardPage_stats__vI-ui","feed":"DashboardPage_feed__HYgFy","relationships":"DashboardPage_relationships__Zb-1P"};